const REALTIME_DATA_VALUE_TYPE = {
  VOLTAGE: "voltage",
  CURRENT: "current",
  ACTIVE_POWER: "activePower",
  REACTION_POWER: "reactionPower",
  APPARENT_POWER: "apparentPower",
  POWER_FACTOR: "powerFactor",
  ENERGY: "energy"
};

const REALTIME_DATA_VALUE_TYPES_ARRAY = Object.values(REALTIME_DATA_VALUE_TYPE);

const REALTIME_DATA_VALUE_TYPE_LABELS = {
  [REALTIME_DATA_VALUE_TYPE.VOLTAGE]: "realtime.data.value.type.voltage",
  [REALTIME_DATA_VALUE_TYPE.CURRENT]: "realtime.data.value.type.current",
  [REALTIME_DATA_VALUE_TYPE.ACTIVE_POWER]: "realtime.data.value.type.activePower",
  [REALTIME_DATA_VALUE_TYPE.REACTION_POWER]: "realtime.data.value.type.reactionPower",
  [REALTIME_DATA_VALUE_TYPE.APPARENT_POWER]: "realtime.data.value.type.apparentPower",
  [REALTIME_DATA_VALUE_TYPE.POWER_FACTOR]: "realtime.data.value.type.powerFactor",
  [REALTIME_DATA_VALUE_TYPE.ENERGY]: "realtime.data.value.type.energy"
};

const REALTIME_DATA_VALUE_TYPE_DIRECT_LABELS = {
  [REALTIME_DATA_VALUE_TYPE.VOLTAGE]: "Voltage",
  [REALTIME_DATA_VALUE_TYPE.CURRENT]: "Current",
  [REALTIME_DATA_VALUE_TYPE.ACTIVE_POWER]: "Active Power",
  [REALTIME_DATA_VALUE_TYPE.REACTION_POWER]: "Reaction Power",
  [REALTIME_DATA_VALUE_TYPE.APPARENT_POWER]: "Apparent Power",
  [REALTIME_DATA_VALUE_TYPE.POWER_FACTOR]: "Power Factor",
  [REALTIME_DATA_VALUE_TYPE.ENERGY]: "Energy",
  "active power": "Active Power",
  "reaction power": "Reaction Power",
  "apparent power": "Apparent Power",
  "power factor": "Power Factor"
};

const REALTIME_DATA_FIELDS = [
  "voltage-Up",
  "voltage-U1",
  "voltage-U2",
  "voltage-U3",
  "voltage-Upavg",
  "voltage-U12",
  "voltage-U23",
  "voltage-U31",
  "voltage-Ulavg",

  "current-I1",
  "current-I2",
  "current-I3",
  "current-I4",
  "current-I5",
  "current-I6",

  "active power",
  "reaction power",
  "apparent power",
  "power factor"
];

const REALTIME_DATA_VALUE_TYPE_TO_FIELD = {
  [REALTIME_DATA_VALUE_TYPE.ACTIVE_POWER]: "active power",
  [REALTIME_DATA_VALUE_TYPE.REACTION_POWER]: "reaction power",
  [REALTIME_DATA_VALUE_TYPE.APPARENT_POWER]: "apparent power",
  [REALTIME_DATA_VALUE_TYPE.POWER_FACTOR]: "power factor"
};

export {
  REALTIME_DATA_VALUE_TYPE,
  REALTIME_DATA_VALUE_TYPE_LABELS,
  REALTIME_DATA_VALUE_TYPES_ARRAY,
  REALTIME_DATA_VALUE_TYPE_DIRECT_LABELS,
  REALTIME_DATA_FIELDS,
  REALTIME_DATA_VALUE_TYPE_TO_FIELD
};
